<template>
	<div class="items">
		<item v-for="item in items" :key="item.id" v-bind="item"/>
	</div>
</template>

<script>
import item from "./item.vue";

export default {
	components: {item},
	props: {
		items: {type: Array, required: true}
	}
};
</script>

<style lang="scss" scoped>
.items {
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;
	@include res(mobile) {
		flex-direction: column;
	}
}
</style>
